import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'eventType'
})
export class EventTypePipe implements PipeTransform {

    transform(value: string, ...args: unknown[]): string {
        if (value === 'new_document') {
            return 'Neues Dokument hochgeladen';
        } else {
            return '';
        }
    }

}
